import { actionForState } from "../../common/functions/utils";

import {
    SU_ADD_PROPERTY,
    SU_DELETE_PROPERTY,
    CHANNEL_MAPPING,
    LOAD_MAPPING_DATA,
} from './types';

import { toast } from "react-toastify";
toast.configure();


export const INITIAL_STATE = {
    channelMappingData: {},
    channels: [],
    properties: [],
    actionForGetChannels: {
        loading: false,
        success: false,
        error: false,
    },
    actionForChannelMapping: {
        loading: false,
        success: false,
        error: false,
    },
    actionForAddProperty: {
        loading: false,
        success: false,
        error: false,
    },
    actionForDeleteProperty: {
        loading: false,
        success: false,
        error: false,
    },
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        
        case LOAD_MAPPING_DATA.pending:
            return {
                ...state,
                actionForGetChannels: actionForState(state.action, 'pending'),
            }
        case LOAD_MAPPING_DATA.success:
            const mappingDataLoaded = action.payload.data;
            return {
                ...state,
                channels: mappingDataLoaded,
                actionForGetChannels: actionForState(state.action, 'success'),
            }
        case LOAD_MAPPING_DATA.error:
            toast.error(action.payload.message)
            return {
                ...state,
                actionForGetChannels: actionForState(state.action, 'error', action.payload.message),
            }
        
        case CHANNEL_MAPPING.pending:
            return {
                ...state,
                actionForChannelMapping: actionForState(state.action, 'pending'),
            }
        case CHANNEL_MAPPING.success:
            const channelMappingData = action.payload.data;
            return {
                ...state,
                channelMappingData: channelMappingData,
                actionForChannelMapping: actionForState(state.action, 'success'),
            }
        case CHANNEL_MAPPING.error:
            toast.error(action.payload.message)
            return {
                ...state,
                actionForChannelMapping: actionForState(state.action, 'error', action.payload.message),
            }
        
        case SU_ADD_PROPERTY.pending:
            return {
                ...state,
                actionForAddProperty: actionForState(state.action, 'pending'),
            }
        case SU_ADD_PROPERTY.success:
            toast.success(action.payload.message);
            return {
                ...state,
                actionForAddProperty: actionForState(state.action, 'success'),
            }
        case SU_ADD_PROPERTY.error:
            toast.error(action.payload.message)
            return {
                ...state,
                actionForAddProperty: actionForState(state.action, 'error', action.payload.message),
            }

        case SU_DELETE_PROPERTY.pending:
            return {
                ...state,
                actionForDeleteProperty: actionForState(state.action, 'pending'),
            }
        case SU_DELETE_PROPERTY.success:
            toast.success("Property has been successfully deleted.");
            return {
                ...state,
                actionForDeleteProperty: actionForState(state.action, 'success'),
            }
        case SU_DELETE_PROPERTY.error:
            toast.error(action.payload.message)
            return {
                ...state,
                actionForDeleteProperty: actionForState(state.action, 'error', action.payload.message),
            }
        
        default:
            return state;
    }
}